import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { IFloatingPopupInstance } from '@app/main/main-content/floating-popup-manager/interfaces/floating-popup-instance';
import { FpLoggerNoisePicturesStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-pictures/services/fp-logger-noise-pictures/fp-logger-noise-pictures.store';
import { FpLoggerNoisePicturesActionType } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-pictures/services/fp-logger-noise-pictures/fp-logger-noise-pictures.actions';
import { FloatingPopupBaseErrorMessageComponent } from '@app/main/main-content/floating-popup-manager/components/floating-popup-base-error-message/floating-popup-base-error-message.component';
import { PictureGalleryListItemComponent } from '@app/core/picture-gallery/components/picture-gallery-list-item/picture-gallery-list-item.component';
import { PictureGallerySliderPopupService } from '@app/core/picture-gallery/services/picture-gallery-slider-popup.service';
import { IDevicePicture } from '@app/api/interfaces/device-picture.interface';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'gc-fp-logger-noise-pictures',
  standalone: true,
  imports: [FloatingPopupBaseErrorMessageComponent, PictureGalleryListItemComponent, TranslateDirective],
  templateUrl: './fp-logger-noise-pictures.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'min-h-0 grow-1',
  },
})
export class FpLoggerNoisePicturesComponent {
  public readonly currentTabStore = inject(FpLoggerNoisePicturesStore);

  private readonly pictureGallerySliderPopupService = inject(PictureGallerySliderPopupService);

  public popup = input<IFloatingPopupInstance>();

  private readonly popupMainData = toSignal(this.currentTabStore.popupMainData$, {
    initialValue: null,
  });

  public readonly data = toSignal(this.currentTabStore.data$, {
    initialValue: null,
  });

  public error = toSignal(this.currentTabStore.error$, {
    initialValue: null,
  });

  public isDataExist = computed(() => !!this.data()?.length);

  public readonly loggerDeployment = computed(() => this.popupMainData()?.deployment);

  public onPictureSelect(picture: IDevicePicture): void {
    this.pictureGallerySliderPopupService.open({
      title$: this.popup()?.title,
      list$: this.currentTabStore.data$.pipe(map(pictures => pictures ?? [])),
      selectWithActive: picture,
      loading$: this.currentTabStore.pictureUpdateLoading$,
      save: (selected: IDevicePicture) => {
        this.currentTabStore.dispatch({
          type: FpLoggerNoisePicturesActionType.UpdatePicture,
          pictureId: selected.id,
          update: { rotation: selected.rotation },
        });
      },
    });
  }
}
